enum ScreenSize {
  sm = '768px',
  md = '992px',
  lg = '1200px',
}

export default ScreenSize;
